import { observer } from 'mobx-react-lite';

import ChartAndDataByMonth from './ChartAndDataByMonth';

const Last12MonthSumary = () => {
  return <ChartAndDataByMonth last12Months={true} />;
};

export default observer(Last12MonthSumary);
